import { AccessLevelType } from 'shared/types/accessLevel';

export interface IAppUserResponse {
  results: IAppUser[];
}

interface IAppUser {
  codigo: number;
  login: string;
  nome: string;
  sobrenome: string;
  cpf: string;
  telefone: string;
  email: string;
  nivel_acesso: 0 | 25 | 50 | 75 | 100 | 125 | 175;
  timezone: string;
  franchise_id: number;
  franchise_owner: number;
  bot: number;
  collective_id: number;
}

export class AppUser {
  code: number;
  name: string;
  lastname: string;
  login: string;
  accessLevel: 0 | 25 | 50 | 75 | 100 | 125 | 175;
  timezone: string;
  cpf: string;
  telefone: string;
  email: string;
  franchiseId: number;
  franchiseOwner: number;
  bot: number;
  collectiveId: number;

  constructor(data: IAppUser) {
    this.code = data.codigo;
    this.name = data.nome;
    this.lastname = data.sobrenome;
    this.login = data.login;
    this.accessLevel = data.nivel_acesso;
    this.timezone = data.timezone;
    this.cpf = data.cpf;
    this.telefone = data.telefone;
    this.email = data.email;
    this.franchiseId = data.franchise_id;
    this.franchiseOwner = data.franchise_owner;
    this.bot = data.bot;
    this.collectiveId = data.collective_id;
  }

  get accessLevelLabel(): string {
    if (!this.accessLevel) return AccessLevelType[0];
    return AccessLevelType[this.accessLevel];
  }

  get fullName(): string {
    return this.lastname ? `${this.name} ${this.lastname}` : this.name;
  }

  get originalPayload(): IAppUser {
    return {
      codigo: this.code,
      nome: this.name,
      sobrenome: this.lastname,
      login: this.login,
      nivel_acesso: this.accessLevel,
      timezone: this.timezone,
      cpf: this.cpf,
      telefone: this.telefone,
      email: this.email,
      franchise_id: this.franchiseId,
      franchise_owner: this.franchiseOwner,
      bot: this.bot,
      collective_id: this.collectiveId,
    };
  }
}
